import axiosClient from "./axiosClient";
import API_ENDPOINTS from "../constants/apiEndpoints";

function extractMessage(error, fallback) {
  const d = error?.response?.data;
  const inner = d?.data;
  return (
    inner?.reason ||
    inner?.message ||
    d?.reason ||
    d?.message ||
    error?.message ||
    fallback
  );
}

function unwrapMediaRows(response) {
  const envelope = response?.data?.data ?? response?.data ?? {};
  const rows = envelope?.data ?? envelope?.media ?? [];
  return {
    rows: Array.isArray(rows) ? rows : [],
    message: envelope?.reason || envelope?.message || "Success",
    meta: {
      pointInTime: envelope?.point_in_time || null,
      statusCode: envelope?.status_code || response?.status,
    },
  };
}

/**
 * POST /media/for-auth-user
 * FormData: user_id, user_email, sub_category
 */
export async function fetchConsumerTopicMedia({ userId, userEmail, subCategory }) {
  if (!userId || !userEmail?.trim() || !subCategory?.trim()) {
    return {
      status: false,
      message: "Missing account or topic details.",
      data: [],
      meta: null,
    };
  }

  const formData = new FormData();
  formData.append("user_id", String(userId));
  formData.append("user_email", String(userEmail).trim());
  formData.append("sub_category", String(subCategory).trim());

  try {
    const response = await axiosClient.post(API_ENDPOINTS.MEDIA.FOR_AUTH_USER, formData, {
      headers: { "Content-Type": "multipart/form-data", Accept: "application/json" },
    });
    const { rows, message, meta } = unwrapMediaRows(response);
    return { status: true, message, data: rows, meta };
  } catch (error) {
    return {
      status: false,
      message: extractMessage(error, "Unable to load media for this topic."),
      data: [],
      meta: null,
    };
  }
}
